import { render } from "./VaIconMenuCollapsed.vue?vue&type=template&id=10f99263"
import script from "./VaIconMenuCollapsed.vue?vue&type=script&lang=js"
export * from "./VaIconMenuCollapsed.vue?vue&type=script&lang=js"

import "./VaIconMenuCollapsed.vue?vue&type=style&index=0&id=10f99263&lang=scss"

import exportComponent from "/home/admin/armada-dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__